import React from "react";
import {Avatar} from "antd";
import {toAgoFormat} from 'util/helpers';


class NotificationItem extends React.Component {

  render() {
    const {notification, id, readNotification} = this.props;
    const {icon, image, title, time} = notification;
    return (
      <li onClick={(e) => readNotification(id)} className="gx-media" style={{
        cursor: 'pointer',
        margin: '0 -16px',
        padding: '12px 6px',
        background: notification.read ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.1)'}}>
        <Avatar className="gx-size-40 gx-mr-3"
                alt={image}
                src={image}/>
        <div className="gx-media-body gx-align-self-center">
          <p className="gx-fs-sm gx-mb-0">{title}</p>
          <i className={`icon icon-${icon} gx-pr-2`}/> <span className="gx-meta-date"><small>{toAgoFormat(new Date(time))}</small></span>
        </div>
      </li>
    );
  }
};

export default NotificationItem;
